import type { FkspRequestStatus } from '../types'

/** Možnosti filtru stavu žádosti (hodnota API + český popisek). */
export const FKSP_STATUS_FILTER_OPTIONS = [
  { value: 'new', label: 'Nový' },
  { value: 'personalista_pending', label: 'Čeká na personalistu' },
  { value: 'personalista_approved', label: 'Schváleno (personalista)' },
  { value: 'personalista_rejected', label: 'Zamítnuto (personalista)' },
  { value: 'zocmos_pending', label: 'Čeká na ZO ČMOS' },
  { value: 'zocmos_approved', label: 'Schváleno (ZO ČMOS)' },
  { value: 'zocmos_rejected', label: 'Zamítnuto (ZO ČMOS)' },
  { value: 'director_pending', label: 'Čeká na ředitele' },
  { value: 'director_approved', label: 'Schváleno (ředitel)' },
  { value: 'director_rejected', label: 'Zamítnuto (ředitel)' },
] as const satisfies ReadonlyArray<{ value: FkspRequestStatus; label: string }>

const LABELS: Record<FkspRequestStatus, string> = Object.fromEntries(
  FKSP_STATUS_FILTER_OPTIONS.map((o) => [o.value, o.label]),
) as Record<FkspRequestStatus, string>

export function fkspStatusLabelCs(status: string | null | undefined): string {
  if (status == null || status === '') return '—'
  return LABELS[status as FkspRequestStatus] ?? status
}

/** Žluté zvýraznění řádku — žádost zpracovaná hlavním ekonomem (FKSP). */
export function fkspRowSxIfEconomProcessed(req: {
  financist_processed_at?: string | null
}): { bgcolor?: string } {
  return req.financist_processed_at ? { bgcolor: '#fff9c4' } : {}
}

export function fkspStatusChipColor(
  status: string | null | undefined
): 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' {
  switch (status) {
    case 'new':
      return 'success'
    case 'personalista_pending':
    case 'zocmos_pending':
    case 'director_pending':
      return 'warning'
    case 'personalista_rejected':
    case 'zocmos_rejected':
    case 'director_rejected':
      return 'error'
    case 'personalista_approved':
    case 'zocmos_approved':
    case 'director_approved':
      return 'success'
    default:
      return 'default'
  }
}
